import * as R from 'ramda';
import classnames from 'classnames';
import React from 'react';
import { node, oneOf, bool, func } from 'prop-types';
import ScrollContainer from '../scrollbar/container';

import Head from './head';
import Row, { ExpandableRow } from './row';
import Cell from './cell';

const filterChildren = (children, type) =>
  React.Children.toArray(children)
    .filter(c => c.type === type);

export const SELECTION_SINGLE = Symbol('single');
export const SELECTION_MULTIPLE = Symbol('multi');

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.getColumns = this.getColumns.bind(this);
    this.getColumn = this.getColumn.bind(this);
    this.updateColumn = this.updateColumn.bind(this);
    this.columns = {};
  }

  shouldComponentUpdate(props) {
    return R.not(R.equals(props, this.props));
  }

  getColumns() {
    return this.columns;
  }

  getColumn(columnId) {
    return this.columns[columnId];
  }

  updateColumn(columdId, props) {
    this.columns[columdId] = props;
  }

  renderRows() {
    const { children, expandable, selectable } = this.props;
    const rows = filterChildren(children, Row);

    return (React.Children.map(rows, (row) => {
      const { expandElement, ...props } = row.props;

      return expandable
        ? (
          <React.Fragment>
            <ExpandableRow
              {...props}
              table={this}
              selectable={selectable}
            />
            {row.props.expanded && (
              <Row cols={row.props.children.length} table={this} style={{ height: 'auto' }}>
                <Cell style={{ height: 'auto' }}>{expandElement}</Cell>
              </Row>
            )}
          </React.Fragment>
        )
        : React.cloneElement(row, {
          table: this,
          selectable,
        });
    }));
  }

  render() {
    const {
      className,
      children,
      selectable,
      selectionType,
      expandable,
      tableRef,
      scrollable,
      ...props
    } = this.props;

    const isMultiSelect = selectionType === SELECTION_MULTIPLE;

    return (
      <table
        ref={tableRef}
        className={classnames(
          'mdc-data-table',
          className,
        )}
        {...props}
      >
        <thead>
          {React.Children.map(
            filterChildren(children, Head),
            child => React.cloneElement(child, {
              table: this,
              selectable: selectable && isMultiSelect,
              expandable,
            }),
          )}
        </thead>
        {scrollable ?
          <ScrollContainer>
            <tbody>{this.renderRows()}</tbody>
          </ScrollContainer> :
          <tbody>{this.renderRows()}</tbody>
        }
      </table>
    );
  }
}

Table.propTypes = {
  children: node.isRequired,
  selectable: bool,
  expandable: bool,
  scrollable: bool,
  selectionType: oneOf([SELECTION_SINGLE, SELECTION_MULTIPLE]),
  tableRef: func,
};

Table.defaultProps = {
  selectable: false,
  expandable: false,
  scrollable: true,
  selectionType: SELECTION_SINGLE,
  tableRef: () => {},
};

export default Table;
